import moment from "moment";
import { useChildSupportOrder } from "../../../contexts/ChildSupportOrderContext";
import { useParticipant } from "../../../contexts/ParticipantContext";
import EmptyStateView from "../../../components/EmptyStateView";
import CreateChildSupportOrderButton from "../../../components/CreateChildSupportOrderButton";
import ChildSupportStatusBadge from "../../../components/ChildSupportOrderStatusBadge";
import { Heading } from "../../../design/heading";
import { Link } from "../../../design/link";

const ChildSupportCurrentOrder = () => {
  const { participants } = useParticipant();
  const { currentChildSupportOrder } = useChildSupportOrder();

  if (!currentChildSupportOrder) {
    return (
      <EmptyStateView
        title="No Child Support Order"
        message="There is no child support order in this matter."
        action={<CreateChildSupportOrderButton />}
      />
    );
  }

  const payer = participants.find(
    (p) => p._id === currentChildSupportOrder.payer,
  );
  const receiver = participants.find(
    (p) => p._id === currentChildSupportOrder.receiver,
  );

  return (
    <div className="p-6 space-y-6 bg-white border shadow-sm rounded-xl">
      <div className="flex items-center justify-between">
        <Heading>Current Child Support Order</Heading>
        <ChildSupportStatusBadge status={currentChildSupportOrder.status} />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <div className="text-sm text-gray-500">Payer</div>
          <Link
            href={`/participant/${payer?._id}`}
            className="text-lg font-medium"
          >
            {payer?.name || "—"}
          </Link>
        </div>

        <div>
          <div className="text-sm text-gray-500">Receiver</div>
          <Link
            href={`/participant/${receiver?._id}`}
            className="text-lg font-medium"
          >
            {receiver?.name || "—"}
          </Link>
        </div>

        <div>
          <div className="text-sm text-gray-500">Monthly Amount</div>
          <div className="text-lg font-semibold">
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(currentChildSupportOrder.amount)}
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-500">Start Date</div>
          <div className="text-lg">
            {moment(currentChildSupportOrder.startDate).format("LL")}
          </div>
        </div>

        {currentChildSupportOrder.endDate && (
          <div>
            <div className="text-sm text-gray-500">End Date</div>
            <div className="text-lg">
              {moment(currentChildSupportOrder.endDate).format("LL")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChildSupportCurrentOrder;
